import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService, MorningMeetingService, ReminderService } from '@org/shared-services';
import { Router } from '@angular/router';

@Component({
    selector: 'app-morning-meeting',
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './morningMeeting.component.html',
    styleUrl: './morningMeeting.component.scss'
})
export class MorningMeetingComponent implements OnInit {
  meetingForm: FormGroup;
  user: any;

  constructor(
    private fb: FormBuilder,
    private morningMeetingService: MorningMeetingService,
    private authService: AuthService,
    private router: Router,
    private reminderService: ReminderService
  ) {
    this.meetingForm = this.fb.group({
      summary: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.user = this.authService.currentUserValue;
  }

  onCancel(): void {
    this.router.navigate(['/mobile/new-task']); // Navigate to dashboard or another page on cancel
  }

  onSubmit(): void {
    if (this.meetingForm.valid) {
      this.morningMeetingService.submitMeetingUpdate(this.meetingForm.value).subscribe(response => {
       
        this.reminderService.setNextReminder(8); // Set the next reminder for 8 AM the next day
        this.router.navigate(['/mobile/new-task']);
      });
    }
  }
}
